import { Link } from 'react-router-dom';

export default function FeaturedArticle() {
  return (
    <section className="py-12 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-8 lg:gap-16 items-center">
          <div className="lg:w-[60%]">
            <p className="text-xs font-medium text-foreground-500 uppercase tracking-wider mb-4">
              <span className="inline-block w-1.5 h-1.5 rounded-full bg-primary-500 mr-2"></span>
              重磅爆料
            </p>
            <blockquote className="text-2xl md:text-3xl lg:text-4xl font-heading font-semibold text-foreground-950 leading-relaxed max-w-xl">
              <span className="text-primary-500 text-5xl md:text-6xl leading-none">&ldquo;</span>
              某知名一线女星近日被狗仔队拍到深夜与一名神秘男子在某五星级酒店同进同出，两人举止亲密。该女星此前一直对外宣称单身，此次被拍引发粉丝和媒体对其感情状况的广泛猜测。
            </blockquote>
            <div className="mt-6 flex items-center gap-3">
              <span className="text-sm font-semibold text-foreground-900">八卦雷达</span>
              <span className="flex items-center gap-1 text-xs text-accent-600 font-medium">
                <i className="ri-verified-badge-fill"></i>
                已核实
              </span>
            </div>
            <Link
              to="/article/zhiming-nvxing-heidong-20260703"
              className="whitespace-nowrap mt-6 inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors duration-200 cursor-pointer"
            >
              阅读全文
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="lg:w-[40%]">
            <div className="rounded-2xl overflow-hidden h-[350px] md:h-[450px] w-full">
              <img
                src="https://readdy.ai/api/search-image?query=Mysterious%20nighttime%20paparazzi%20style%20scene%20with%20warm%20city%20lights%20blurred%20in%20background%2C%20two%20silhouettes%20near%20a%20luxury%20hotel%20entrance%2C%20dramatic%20ambient%20lighting%20with%20golden%20and%20deep%20crimson%20tones%2C%20cinematic%20atmosphere%2C%20editorial%20photography%20aesthetic%2C%20moody%20and%20intriguing%20composition&width=600&height=800&seq=featured-article-main&orientation=portrait"
                alt="知名女星被拍到深夜密会神秘男子"
                title="知名女星 恋情 狗仔爆料"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}